import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { colors } from '../../../../../../../colorVars';
import style from './TopRowBoxIncDecButtons.module.css';

export const TopRowBoxIncDecButtons = ({
  backgroundColor,
  width,
  justifyContent,
  qty,
  setQty,
  totalTradePlanQty,
  type,
}) => {
  const increment = () => {
    setQty((prev) => {
      if (prev + 1 > totalTradePlanQty && type === 'close')
        return totalTradePlanQty;
      else return prev + 1;
    });
  };
  const decrement = () => {
    setQty((prev) => {
      if (prev - 1 < 1) return 1;
      else return prev - 1;
    });
  };
  useEffect(() => {
    if (type === 'close' && qty > totalTradePlanQty) setQty(totalTradePlanQty);
  }, [type, totalTradePlanQty, qty, setQty]);
  return (
    <div
      className={style.box}
      style={{ backgroundColor, width, justifyContent }}
    >
      <div onClick={decrement} className={style.button}>
        <svg
          className={style.svg}
          height={10}
          width={10}
          fill={colors.lightGrey}
        >
          <polygon points="0,0 10,0 5,10" />
        </svg>
      </div>
      <div onClick={increment} className={style.button}>
        <svg
          className={style.svg}
          height={10}
          width={10}
          fill={colors.lightGrey}
        >
          <polygon points="0,0 10,0 5,10" transform="rotate(180, 5, 5)" />
        </svg>
      </div>
    </div>
  );
};

TopRowBoxIncDecButtons.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.string,
  color: PropTypes.string,
  justifyContent: PropTypes.string,
  qty: PropTypes.any,
  setQty: PropTypes.func,
  totalTradePlanQty: PropTypes.any,
  type: PropTypes.string,
  width: PropTypes.string,
};
